import React, { useState } from 'react'
import useTrans from 'hooks/useTrans'
import { PaginaType } from 'utils/types'
import { MyOptinsFormCard, MyAccountLayout, Page } from 'components/organisms'
import styles from './MyAccountPreferenzeTemplate.module.sass'
import { MyAccountSection } from '@components/molecules'
import { Logout } from '@components/atoms/Icons'
import Link from 'next/link'

interface IBrandOptin{
    node: {
        name: string
        image: string
        value: boolean
        optinName: string
    }
}

interface Props {
  pagina: PaginaType
  optins?: {
    optinBrands: IBrandOptin[]
    optinMarketing: string
    optinProgramMarketing2: string
  }
}

const MyAccountPreferenzeTemplate = ({ optins, pagina }: Props) => {
  const t = useTrans()

  return (
    <Page pagina={pagina} item={{}}>
      <MyAccountLayout
        titolo={pagina.titolo}
        descrizione={pagina.descrizione}
        menuActiveItemKey="privacy"
        backLink={false}
      >
          <MyOptinsFormCard dati={{ ...optins }}/>
      <MyAccountSection
          className={styles.myAccountSectionLogoutMobile}
          bodyClassName={styles.myAccountSectionLogoutMobileBody}
        >
                  <Link legacyBehavior href="/logout">
                    <a className={styles.logout}>
                      <span className={styles.logoutIcon}>
                        <Logout />
                      </span>
                      <span className={styles.logoutLabel}>{t('Esci')}</span>
                    </a>
                  </Link>
                </MyAccountSection>
      </MyAccountLayout>
    </Page>
  )
}

export default MyAccountPreferenzeTemplate
